const KEY = 'gaurik_gods_badges';

export function getBadges() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function awardBadge(religionId) {
  const badges = getBadges();
  if (badges.includes(religionId)) return false;
  localStorage.setItem(KEY, JSON.stringify([...badges, religionId]));
  return true;
}
